import React, { PureComponent, useContext } from 'react';
import PropTypes from 'prop-types';

import ShowChartOutlinedIcon from '@mui/icons-material/ShowChartOutlined'
import DataUsageOutlinedIcon from '@mui/icons-material/DataUsageOutlined'
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined'
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined'
import LoyaltyOutlinedIcon from '@mui/icons-material/LoyaltyOutlined'
import SettingsApplicationsOutlinedIcon from '@mui/icons-material/SettingsApplicationsOutlined'
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined'
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined'
import FindInPageOutlinedIcon from '@mui/icons-material/FindInPageOutlined';

import FiranoIcon from 'cityads-v3/components/Icons/FiranoIcon';

import Carousel, { SlideCardContext } from './Carousel';
import { ClickableCardWithPopup } from '../CardWithPopup';
import Typography from '@mui/material/Typography'

import classes from './ToolsCarousel.scss'

export const ALLOWED_PATHS = [
  'statistics',
  'big_data',
  'agent_cabinet',
  'firano',
  'product_feed',
  'coupon_feed',
  'getlink',
  'api',
  'conversion_postback',
  'widgets',
  'lost_orders',
];

const ICONS = {
  show_chart: <ShowChartOutlinedIcon />,
  data_usage: <DataUsageOutlinedIcon />,
  exit_to_app: <ExitToAppOutlinedIcon />,
  attach_money: <FiranoIcon />,
  shopping_cart: <ShoppingCartOutlinedIcon />,
  loyalty: <LoyaltyOutlinedIcon />,
  settings_applications: <SettingsApplicationsOutlinedIcon />,
  refresh: <RefreshOutlinedIcon />,
  widgets: <WidgetsOutlinedIcon />,
  find_in_page: <FindInPageOutlinedIcon />,
}

export default class ToolsCarousel extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    limits   : PropTypes.object,
    items    : PropTypes.arrayOf(PropTypes.object).isRequired,
    moreRoot : PropTypes.string,
    lessLink : PropTypes.string,
  }

  render() {
    const { items, moreRoot, lessLink, ...rest } = this.props;

    return (
      <Carousel
        {...rest}
      >
        {items.map((item, index) => (
          <CarouselCardWrapper key={index} {...item} moreRoot={moreRoot} lessLink={lessLink} />
        ))}
      </Carousel>
    );
  }
}

function CarouselCardWrapper({ icon, title, subtitle, moreRoot, moreLink, lessLink, flag, children, ...rest }) {
  const getHidePopup = useContext(SlideCardContext);

  return (
    <ClickableCardWithPopup
      {...rest}
      icon      = {ICONS[icon]}
      title={<Typography component="h3" color="textPrimary">{title}</Typography>}
      subtitle  = {<div className={classes.cardSubtitle}>{subtitle}</div>}
      isMini    = {true}
      moreLink  = {moreLink ? (moreRoot + '/' + moreLink) : null}
      lessLink  = {lessLink}
      hidePopup = {getHidePopup}
      classes   = {{ root: classes.cardRoot }}
      cardHeaderClasses  = {{ root: classes.cardHeader, title: classes.cardHeaderTitle, subheader: classes.cardHeaderSub }}
      cardContentClasses = {{ root: classes.cardContent }}
    >
      <div className={classes.cardContainerStyle}>
        {flag ?
          (
            <span className={classes.cardFlag}>{flag}</span>
          ) :
          null
        }
        {children}
      </div>
    </ClickableCardWithPopup>
  );
}
